export const SEARCHING_DROPDOWN_PANEL_CLASS = 'searching';
